export const baseURL = 'https://openschedule-1-r7691628.deta.app/'
